import * as React from 'react';
import styles from './styles.scss';

export interface Props {
  missingText: string;
}

const MissingUtbedring = ({ missingText }: Props): JSX.Element => {
  return (
    <div className={styles.card}>
      <div className={styles.ok}>
        <span>👌</span>
      </div>
      <div>
        <span>{missingText}</span>
      </div>
    </div>
  );
};

export default MissingUtbedring;
